import { defineChain } from "viem";
import { ACTIVE_CHAIN } from "../config/chains";

/** viem chain for Robinhood Chain Testnet, derived from canonical config. */
export const robinhoodTestnet = defineChain({
  id: ACTIVE_CHAIN.chainId,
  name: ACTIVE_CHAIN.label,
  nativeCurrency: ACTIVE_CHAIN.nativeCurrency,
  rpcUrls: { default: { http: [ACTIVE_CHAIN.rpcUrl] } },
  blockExplorers: {
    default: { name: "Explorer", url: ACTIVE_CHAIN.explorerUrl },
  },
  testnet: true,
});
